/*
 * Angel Twin Privacy Policy Page
 */
import React, { useEffect, useState, Suspense, lazy } from 'react';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import "./index.css";
import axios from 'axios';
import parser from 'html-react-parser';
import privacyJsonData from "./privacypolicy.json";
const Footer = lazy(() => import("../FooterNewChanges/FooterNewChanges"));

const AngelTwinPrivacyPolicy = () => {
  const [privacyPolicyData, setPrivacyPolicyData] = useState();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    /**
     * Check if the device is mobile
     */
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {

    const fetchPrivacyPolicy = async () => {
      const cdnUrl = `${process.env.REACT_APP_CDN_LINK}myanglai/privacypolicy.json`;

      try {
        const response = await axios.get(cdnUrl, { timeout: 5000 }); // Timeout after 5s
        if (response.data && (response.data.data || response.data.disclaimer)) {
          setPrivacyPolicyData(response.data.data || response.data);
        } else {
          throw new Error("Invalid JSON structure from CDN");
        }
      } catch (error) {
        console.warn("CDN fetch failed, using local JSON:", error.message);
        setPrivacyPolicyData(privacyJsonData);
      }
    };

    fetchPrivacyPolicy();
  }, []);


  return (
    <article>
      <div className='privacy-policy-container'>
        <div className="privacy-banner" style={{ backgroundColor: "rgb(2, 3, 53)" }}>
          {/* Video Section */}
          <video
            className="banner-video"
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          >
            <source
              src={
                process.env.REACT_APP_CDN_LINK +
                (isMobile
                  ? "angeltwin/banner-video-mobile.mp4"
                  : "angeltwin/banner-video-desktop.mp4")
              }
              type="video/mp4"
            />
          </video>

          {/* Content Section */}
          <Container style={{ zIndex: "2" }}>
            <Row>
              <Col>
                <div>
                  <h1 className="privacy-heading">Privacy Policy</h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <Container>
          {privacyPolicyData ?
            <Row className="privacyRow">
              <Col md={12} className="angeltwinDisclaimer pt-5">

                {privacyPolicyData.disclaimer?.map((disclaimer, i) => (
                  <p key={i}>
                    {parser(disclaimer)}
                  </p>
                ))}
              </Col>

              {privacyPolicyData.privacyPolicy?.map((policyItem, j) => (
                <Col md={12} key={j}>
                  <div className="policy_header" />
                  <div className="policy_content">
                    {/* Render heading without numbers */}
                    <p className="heading">{parser(policyItem.heading)}</p>

                    {/* Render description paragraphs */}
                    {policyItem.description.map((descriptionData, k) => (
                      <p key={k}>
                        {parser(descriptionData)}
                      </p>
                    ))}
                  </div>
                </Col>
              ))}
            </Row>
            : <Row>
              <Col className="text-center py-5">
                <p>Loading privacy policy...</p>
              </Col>
            </Row>}
        </Container>
        <div className='mt-4'>
          <Suspense fallback={<div />}>
            <Footer />
          </Suspense>
        </div>
      </div>
    </article>
  );
};

export default AngelTwinPrivacyPolicy;